export const DECA_ROUTES = {
  NEW: '/deca-new',
  TRANSFER: '/deca-transfer',
  LIST: '/deca',
  DETAIL: '/deca-detail',
  EDIT: '/deca-edit',
} as const;
